import { HeroSection } from "@/components/landing/HeroSection";
import {
  ProcessSection,
  FeaturesSection,
  CTASection,
  FooterSection,
} from "@/components/landing/FeaturesSection";

export default function LandingPage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ProcessSection />
      <FeaturesSection />
      <CTASection />
      <FooterSection />
    </div>
  );
}
